type SectionHeadingProps = {
  kicker: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  accent?: boolean;
};

export default function SectionHeading({ kicker, title, desc, actionLabel, accent = false }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-background-200 pb-5 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <span
          className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium ${
            accent ? 'bg-accent-100 text-accent-900' : 'bg-primary-50 text-primary-700'
          }`}
        >
          <i className="ri-bookmark-line" />
          {kicker}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>}
      </div>
      {actionLabel && (
        <a
          href="#top"
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </a>
      )}
    </div>
  );
}